import { takeLatest, call, select, put } from 'redux-saga/effects';
import queryString from 'query-string';
import axios from '../axiosConfig';
import {
  getCheckAirAvailabilityRequest,
  getCheckAirAvailabilitySuccess,
} from '../../slices/flight';
import flightSearchInput from '../../../helpers/selectors/flightSearchInput';
import formatCheckAirAvailabilityRequest from '../../../helpers/formatCheckAirAvailabilityRequest';
import validateCheckAvailabiltyRequest from '../../../helpers/validationHelpers/validateCheckAvailabilityRequest';

function* checkAirAvailabilityWorker({ payload }) {
  const { tripId, isTripSearch, key, currentIndex } = payload || {};
  try {
    const { searchInputs } = yield select(flightSearchInput(tripId, isTripSearch));

    if (!isTripSearch) {
      const { isValid, message } = validateCheckAvailabiltyRequest(
        searchInputs?.flightSegments?.[currentIndex],
      );
      if (!isValid) {
        yield put(getCheckAirAvailabilitySuccess({ responseData: {}, error: message, key }));
        return;
      }
    }
    const query = queryString.stringify(
      formatCheckAirAvailabilityRequest(searchInputs, currentIndex),
      { skipNull: true },
    );
    const { data } = yield call(axios.post, `/flights/airAvailabilities?${query}`);
    yield put(getCheckAirAvailabilitySuccess({ responseData: data, key }));
  } catch (error) {
    yield put(getCheckAirAvailabilitySuccess({ responseData: {}, error, key }));
  }
}

export default function* checkAirAvailabilityWatcher() {
  yield takeLatest(getCheckAirAvailabilityRequest.toString(), checkAirAvailabilityWorker);
}
